import { Columns2 } from 'lucide-react';
import type { ColumnsBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const columnsConfig: BlockTypeConfig<ColumnsBlock> = {
  type: 'columns',
  label: 'Columns',
  description: 'Multi-column layout with nested blocks',
  icon: Columns2,
  category: 'layout',
  createDefault: () => ({
    columns: [
      { id: crypto.randomUUID(), blocks: [] },
      { id: crypto.randomUUID(), blocks: [] },
    ],
    layout: '1-1',
    gap: 'md',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.layout',
      label: 'Layout',
      options: [
        { value: '1-1', label: '1:1' },
        { value: '1-2', label: '1:2' },
        { value: '2-1', label: '2:1' },
        { value: '1-1-1', label: '1:1:1' },
        { value: '1-2-1', label: '1:2:1' },
      ],
    },
    {
      kind: 'select',
      path: 'data.gap',
      label: 'Gap',
      options: [
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [],
  container: {
    childPaths: ['data.columns[0].blocks', 'data.columns[1].blocks', 'data.columns[2].blocks'],
  },
};
